import React from 'react'
import { Widget } from 'widgets-for-react'
import { any, fromJSX, Updater } from 'widgets-for-react'
import { blocksWidget } from '../../blocks/blocksWidget'
import { cmsPageStateUpdaters, FriendPage, Page } from '../../cmsPageState'
import { FriendPageHeader } from './friendPageLayout'

export const friendPageWidget =
  (acceptVideoCookie: () => void) =>
  (page: FriendPage): Widget<Updater<Page>> =>
    any([
      fromJSX((setState) => (
        <FriendPageHeader
          toggleMenu={() => setState(cmsPageStateUpdaters.menuOpenedUpdater)}
          menuOpened={page.menuOpened}
          title={page.title}
          intro={page.intro}
          image={page.image}
          showSideMenu={page.showSidemenu}
          breadcrumbs={
            page.kind === 'friend'
              ? [
                  { title: 'Spaarne Gasthuis', url: '/' },
                  { title: 'Vrienden', url: '/vrienden' },
                  { title: page.title, url: page.url },
                ]
              : [
                  { title: 'Spaarne Gasthuis', url: '/' },
                  { title: page.title, url: page.url },
                ]
          }
        />
      )),
      blocksWidget(acceptVideoCookie)(page.blocks).map((updater) => cmsPageStateUpdaters.blocksUpdater(updater)),
    ])
